var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',[(_vm.hasResults)?_c('information-overview-tab',{staticClass:"accessible",attrs:{"mode":"details"}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }